import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import Image from 'components/Image';
import { getImageFromImageObject } from 'components/Image/utils';
import s from './ElectionStates.scss';

const ElectionStates = props => {
  const { item = {}, item: { data = [], items = [] } } = props;
  const statesData = Array.isArray(data) && data.length > 0 ? data : items;
  if (!(item && Array.isArray(statesData))) {
    return null;
  }
  return (
    <div className={s.keystates}>
      {item.name ? <h3>{item.name}</h3> : ''}
      <div className={s.statelinkWrapeer}>
        <div>
          {statesData.map(node => {
            const name = node.hl || '';
            const { image = {}, imageid, imagesize, gaData = {} } = node;
            if (!(image && image.id)) {
              image.id = imageid;
              image.version = imagesize;
            }
            const imageSrc = getImageFromImageObject(image);

            return (
              <Link to={node.wu} className={s.statelink} data={gaData}>
                {imageSrc && (
                  <Image
                    src={imageSrc}
                    placeHolderSrc="https://static.toiimg.com/photo/msid-25581306/25581306.jpg"
                    lazyload
                    offsetVertical={500}
                    alt={name}
                  />
                )}
                {name}
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

ElectionStates.propTypes = {
  item: PropTypes.shape({}),
};
ElectionStates.defaultProps = {
  item: {},
};

export default ElectionStates;
